import axiosInstance from '@/setup/axios/axiosInstance';
import type { InventoryItemOption } from '../models/ItemModel';

interface MaterialTypeApiItem {
  id: string | number;
  code?: string;
  name?: string;
  title?: string;
  company_id?: string;
  company?: {
    id?: string;
    company_id?: string;
  };
}

const toInventoryItemOption = (item: MaterialTypeApiItem): InventoryItemOption => ({
  id: String(item.id),
  name: item.name || item.title || String(item.id),
  company_id: item.company_id || item.company?.company_id || item.company?.id,
});

const unwrapListData = (data: any): MaterialTypeApiItem[] => {
  if (Array.isArray(data)) {
    return data;
  }

  if (Array.isArray(data?.results)) {
    return data.results;
  }

  return [];
};

export const getMaterialTypeOptions = async (_companyId?: string): Promise<InventoryItemOption[]> => {
  const response = await axiosInstance.get('/inventory/material-types/', {
    params: { page_size: '1000' },
  });
  const items = unwrapListData(response.data);
  return items.map(toInventoryItemOption);
};

export const createMaterialTypeOption = async (payload: { name: string; company_id: string }): Promise<InventoryItemOption> => {
  const response = await axiosInstance.post('/inventory/material-types/', payload);
  return toInventoryItemOption(response.data);
};

export const deleteMaterialTypeOption = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/inventory/material-types/${id}/`);
};
